import { useDispatch, useSelector } from "react-redux"
import { addCost, fetchConditionCosts, selectCostType, selectEditingStatus, updateVendorCondition } from "../../../../redux/features/configuration/parts/vendorCostSlice"
import Input from "../../../../components/Inputs/Input";
import { useEffect, useRef } from "react";
import { HistoryItem } from "./HistoryItem";
const conditionProp = {
    "C": "partConditionId",
    "R": "repairTypeId"
}

export const VendorTabContent = ({part, vendorTempId, TATInfo, conditionIdx}) => {
    const editingStatus = useSelector(selectEditingStatus);
    const isEditing = editingStatus[vendorTempId];
    const costType = useSelector(selectCostType);
    const dispatch = useDispatch();

    const conditionCostsLength = useRef(0);
    const costListRef = useRef(null);

    const handleFormChange = (e) =>{
        let {name, value} = e.target;
        dispatch(updateVendorCondition({
            conditionIdx,
            vendorTempId,
            name,
            value: isNaN(parseInt(value)) ? "" : parseInt(value)
        }))
    };

    const createNewList = (e) => {
        dispatch(addCost({vendorTempId}));
        
       
        //TODO:
    }

    useEffect(()=>{
        dispatch(fetchConditionCosts({tatId: TATInfo.id, vendorTempId, conditionIdx}));
    },[]);

    useEffect(()=>{
        let newValue = TATInfo?.conditionCosts?.length ?? 0;
        if (newValue === conditionCostsLength.current + 1) {
            costListRef?.current?.querySelector("details").setAttribute("open", true);
        }
        conditionCostsLength.current = newValue;

    },[TATInfo])

    return (
        <div className='vendor-tab-content-component'>
            <div className='header'>
                <b>Vendor Information</b>
            </div>
            <div className='tat-container'>
                {/* {JSON.stringify(TATInfo?? false)} */}
                <div className='tat-item'>
                    <span>Estimated Turn Around Time (TAT)</span>
                    <Input disableAutocomplete disabled={!isEditing} value={TATInfo?.tat_estimated ?? ""} label="" name="tat_estimated" isNumeric onChange={handleFormChange} />
                    <span>Days</span>
                </div>
                <div className='tat-item'>
                    <span>Average Turn Around Time</span>
                    <Input disableAutocomplete disabled={true} value={TATInfo?.tat_average ?? ""} name="tat_average" onChange={handleFormChange} label="" isNumeric />
                    <span>Days</span>
                </div>
            </div>
            <div className='warranty'>
                <div className='warranty-item'>
                    <span style={{ color: 'transparent' }}>
                        .
                    </span>

                    <b>Warranty</b>
                </div>
                <div className='warranty-item'>
                    <span>
                        Hours
                    </span>
                    <Input disableAutocomplete disabled={!isEditing} value={TATInfo?.warranty_hours ?? ""} name="warranty_hours" onChange={handleFormChange} label="" isNumeric />
                </div>
                <div className='warranty-item'>
                    <span>
                        Cycles
                    </span>
                    <Input disableAutocomplete disabled={!isEditing} value={TATInfo?.warranty_cycles ?? ""} name="warranty_cycles" onChange={handleFormChange} label="" isNumeric />
                </div>
                <div className='warranty-item'>
                    <span>
                        Aircraft Days
                    </span>
                    <Input disableAutocomplete disabled={!isEditing} value={TATInfo?.warranty_aircraft_days ?? ""} name="warranty_aircraft_days" onChange={handleFormChange} label="" isNumeric />
                </div>
                <div className='warranty-item'>
                    <span>
                        Calendar Days
                    </span>
                    <Input disableAutocomplete disabled={!isEditing} value={TATInfo?.warranty_calendar_days ?? ""} name="warranty_calendar_days" onChange={handleFormChange} label="" isNumeric />
                </div>
            </div>

            {/* {JSON.stringify(TATInfo.conditionCosts)} */}

            <div className='cost-container'>
                <div className='header'>
                    <div>
                        <i className='icon-report-checked'></i>
                        <b>Cost per Quantity Range and Cost History</b>
                    </div>
                    {isEditing && <button onClick={createNewList} className='filled small-size'>
                        New List
                    </button>}
                </div>
                <div className='history'>
                    <div className='history-header'>
                        <b>Initial Date</b>
                        <b>Final Date</b>
                        <b>Unit Cost</b>
                        <b></b>
                    </div>
                    {
                        (!(TATInfo.conditionCosts?.length > 0)) && <div className='placeholder-component'><i>No costs configured yet</i></div>
                    }
                    {TATInfo.conditionCosts && <div className='history-list' ref={costListRef}>


                        {TATInfo.conditionCosts?.map((i, idx) => <HistoryItem part={part} idx={idx} item={i} conditionIdx={conditionIdx} />)

                        }
                    </div>}
                </div>
            </div>


        </div>

        

    )
}